import React from 'react';
import { ColorPicker, IColor } from '@fluentui/react';
import { DeleteRegular } from '@fluentui/react-icons';
import {
  Tooltip, tokens, Button,
  mergeClasses
} from '@fluentui/react-components';
import { useStyles, colorPickerStyles } from './style';
import { AdsColorPickerProps, TooltipContentProps } from './type';

const TooltipContent = ({
  colorData, onColorChange, onDelete, i18n,
}: TooltipContentProps) => {
  const classes = useStyles();
  return (
    <>
      <ColorPicker
        color={colorData.HexCode}
        onChange={onColorChange}
        alphaType="none"
        className="color_picker_tooltip"
        showPreview
        styles={colorPickerStyles}
      />
      {onDelete &&
        <>
          <hr className={classes.hr} />
          <Button
            icon={<DeleteRegular color={tokens.colorNeutralForeground2} />}
            data-colorid={colorData.Name}
            onClick={onDelete}
            className={mergeClasses(classes.delBtn, 'delete_color_btn')}
          >
            {i18n.getString(_TL_('Delete color'))}
          </Button>
        </>
      }
    </>
  );
};

const AdsColorPicker: React.FC<AdsColorPickerProps> = ({
  i18n,
  children,
  colorData,
  isColorSelected,
  onDelete,
  updateColor,
  onTooltipVisibilityChange,
}) => {
  const onColorChange = (ev: React.SyntheticEvent<HTMLElement>, colorObj: IColor) => {
    updateColor(colorData.Name, colorObj);
    ev.stopPropagation();
  };
  const classes = useStyles();
  return (
    <Tooltip
      content={{
      children: <TooltipContent i18n={i18n} colorData={colorData} onColorChange={onColorChange} onDelete={onDelete} />,
      className: classes.tooltip,
      }}
      withArrow
      relationship="label"
      positioning="below"
      visible={isColorSelected}
      onVisibleChange={(_ev, data) => onTooltipVisibilityChange && onTooltipVisibilityChange(data.visible)}
    >
      {React.isValidElement(children) ? children : null}
    </Tooltip>
  );
};
const MemoizedAdsColorPicker = React.memo(AdsColorPicker);
export default MemoizedAdsColorPicker;

